<div class="igo-user-button-container">
  <button
    mat-icon-button
    [matTooltip]="
      enabled()
        ? ('igo.geo.mapButtons.online' | translate)
        : ('igo.geo.mapButtons.offline' | translate)
    "
    matTooltipPosition="left"
    [ngClass]="[btnStyle]"
    [color]="enabled() ? color() : null"
    (click)="onClick()"
  >
    <mat-icon>wifi_off</mat-icon>
  </button>
</div>
